import { FaTiktok } from "react-icons/fa6";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { toast } from "sonner";

// One-tap deep-links to each platform's upload page. After downloading the MP4,
// the creator clicks a platform and selects the file there (platforms don't allow
// passing a local file via URL, so this opens the upload screen ready to go).
const PLATFORMS = [
  { key: "tiktok", label: "TikTok", url: "https://www.tiktok.com/tiktokstudio/upload", Icon: FaTiktok, color: "hover:text-white hover:bg-white/10" },
  { key: "instagram", label: "Instagram", url: "https://www.instagram.com/", Icon: FaInstagram, color: "hover:text-pink-400 hover:bg-pink-500/10" },
  { key: "facebook", label: "Facebook", url: "https://www.facebook.com/reels/create", Icon: FaFacebookF, color: "hover:text-blue-400 hover:bg-blue-500/10" },
];

export const ShareToSocial = ({ className = "", compact = false }) => (
  <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="share-to-social">
    <span className={`text-xs text-zinc-500 mr-1 ${compact ? "inline" : "hidden sm:inline"}`}>Post to:</span>
    {PLATFORMS.map(({ key, label, url, Icon, color }) => (
      <a
        key={key}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`share-${key}-btn`}
        title={`Open ${label} upload — then select the MP4 you downloaded`}
        onClick={(e) => { e.stopPropagation(); toast.info(`Opening ${label} — choose your downloaded MP4 to post.`); }}
        className={`inline-flex items-center justify-center rounded-md border border-white/10 bg-white/5 text-zinc-300 transition-colors ${compact ? "h-7 w-7" : "h-9 w-9"} ${color}`}
      >
        <Icon className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
      </a>
    ))}
  </div>
);

export default ShareToSocial;
